export const getMatchStringRegExp = (string) => {
    return new RegExp(String.raw `(?:^|)${string}(?:\s|$)`, "gm");
};
export const getMatchChar = (char) => {
    return new RegExp(String.raw `\B[${char}]\w\S+`, "gm");
};
//# sourceMappingURL=regexp.js.map